import { memo } from "react"

const IconInformativeError = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_3987_10410)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8 16C12.4182 16 16 12.4182 16 8C16 3.58172 12.4182 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4182 3.58172 16 8 16ZM8.8 4.8C8.8 5.24182 8.44184 5.6 8 5.6C7.55816 5.6 7.2 5.24182 7.2 4.8C7.2 4.35818 7.55816 4 8 4C8.44184 4 8.8 4.35818 8.8 4.8ZM7.2 7.2C7.2 6.75816 7.55816 6.4 8 6.4C8.44184 6.4 8.8 6.75816 8.8 7.2V11.2C8.8 11.6418 8.44184 12 8 12C7.55816 12 7.2 11.6418 7.2 11.2V7.2Z"
          fill="#ED4040"
        />
      </g>
      <defs>
        <clipPath id="clip0_3987_10410">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default memo(IconInformativeError)
